"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.StackedIcons = void 0;
var classnames_1 = __importDefault(require("classnames"));
var react_1 = __importDefault(require("react"));
require("./StackedIcons.scss");
var StackedIcons = function (props) { return (react_1.default.createElement("span", { className: classnames_1.default('stacked-icons', 'fa-stack', { tooltip: props.tooltipMsg }, props.className), "data-tooltip": props.tooltipMsg, onClick: props.onClick },
    react_1.default.createElement("i", { className: classnames_1.default(props.innerIcon, 'fa-stack-1x') }),
    react_1.default.createElement("i", { className: classnames_1.default(props.outerIcon, 'fa-stack-2x') }))); };
exports.StackedIcons = StackedIcons;
